import { Button, Card } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";

export default function PowerfullSecurity({ setNextPage, cardAnim }) {
  return (
    <>
      <motion.div key="step3" {...cardAnim}>
        <Card
          className="border-0 shadow-lg"
          style={{ borderRadius: "18px", width: 420 }}
        >
          <Card.Body className="p-4">
            <div className="text-center mb-4">
              <h4 className="fw-bold mb-2">Powerful security 🔐</h4>
              <small className="text-muted">
                Built to protect your data at every step
              </small>
            </div>

            <div className="text-center mb-4">
              <p className="mb-0">
                Your <b>Password</b> and <b>Secret Key</b> work together
              </p>
              <p className="mb-0">
                like <b>two keys to one lock</b>.
              </p>
            </div>
            <div
              className="rounded-3 p-3 mb-4 bg-secondary-subtle"
              style={{ fontSize: 13 }}
            >
              <p className="mb-0">
                🔑 <b>Both</b> are required to set up new devices
              </p>
              <p className="mb-0">
                🔓 You only need your <b>Password</b> to unlock your vault
              </p>
            </div>

            <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}>
              <Button
                onClick={() => setNextPage("setUpPassword")}
                className="w-100 py-2 fw-bold btn-gradient"
              >
                Continue <FaArrowRight />
              </Button>
            </motion.div>
          </Card.Body>
        </Card>
      </motion.div>
    </>
  );
}
